export const registerFavouritesComponent = (Alpine) => {
  Alpine.data('favouritesWidget', () => ({
    posts: [],
    init() {
      this.refreshPosts();
      this.$watch(
        () => Alpine.store('app')?.favourites,
        () => this.refreshPosts()
      );
    },
    refreshPosts() {
      const favourites = Alpine.store('app')?.favourites;
      this.posts = Array.isArray(favourites) ? favourites : [];
    },
    formatDate(value) {
      if (!value) {
        return '';
      }
      try {
        return new Date(value).toLocaleDateString(undefined, {
          year: 'numeric',
          month: 'short',
          day: 'numeric',
        });
      } catch (error) {
        return value;
      }
    },
  }));
};
